import { makeContextModule } from '@cian/react-utils';
import { IApplicationContext } from 'shared/mf-infrastructure/types/applicationContext';

export const {
  Context: ApplicationContext,
  useContext: useApplicationContext,
  withContext: withApplicationContext,
} = makeContextModule<IApplicationContext>({
  contextName: 'ApplicationContext',
});
